export const LADE_AUSWAHLWERTE_NOTEN = "ladeAuswahlwerteNoten";
export const LADE_NOTENSTRUKTUR_ABSCHLUESSE = "ladeNotenstrukturAbschluesse";
export const LADE_FAECHER = "ladeFaecher";
